import { useEffect, useRef } from 'react'
import { UseOutsideClickParams } from './interfaces/useOutsideClick.interface'

const useOutsideClick = ({ ref, onOutsideClick }: UseOutsideClickParams) => {
  // Keep the latest callback so the once-registered listener never runs a stale
  // closure (e.g. a conditional handler like `isChildOpen ? noop : close` would
  // otherwise stay pinned to its first-render branch forever).
  const onOutsideClickRef = useRef(onOutsideClick)
  onOutsideClickRef.current = onOutsideClick

  useEffect(() => {
    const handleListener = (event: MouseEvent | TouchEvent) => {
      if (ref.current && ref.current.contains(event.target as Node)) {
        return
      }
      onOutsideClickRef.current(event)
    }

    document.addEventListener('mousedown', handleListener)
    document.addEventListener('touchstart', handleListener)

    return () => {
      document.removeEventListener('mousedown', handleListener)
      document.removeEventListener('touchstart', handleListener)
    }
  }, [])
}

export default useOutsideClick
